/**
 * @generated SignedSource<<e8b0f1f27f8677a612b8467c60d80374>>
 * @relayHash 972dca7324a265c39d2f2ff53ef8dce7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 972dca7324a265c39d2f2ff53ef8dce7

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateIssueIssueTypeInput = {
  clientMutationId?: string | null;
  issueId: string;
  issueTypeId?: string | null;
};
export type updateIssueIssueTypePickerMutation$variables = {
  input: UpdateIssueIssueTypeInput;
};
export type updateIssueIssueTypePickerMutation$data = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly id: string;
      readonly issueType: {
        readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
      } | null;
    } | null;
  } | null;
};
export type updateIssueIssueTypePickerMutation$rawResponse = {
  readonly updateIssueIssueType: {
    readonly issue: {
      readonly id: string;
      readonly issueType: {
        readonly id: string;
        readonly isEnabled: boolean;
        readonly name: string;
      } | null;
    } | null;
  } | null;
};
export type updateIssueIssueTypePickerMutation = {
  rawResponse: updateIssueIssueTypePickerMutation$rawResponse;
  response: updateIssueIssueTypePickerMutation$data;
  variables: updateIssueIssueTypePickerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueIssueTypePickerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "IssueTypePickerIssueType",
                    "selections": (v3/*: any*/),
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueIssueTypePickerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueIssueTypePayload",
        "kind": "LinkedField",
        "name": "updateIssueIssueType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "972dca7324a265c39d2f2ff53ef8dce7",
    "metadata": {},
    "name": "updateIssueIssueTypePickerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "208e0c9c5dd2d3227c89c8cf3bdbb7bc";

export default node;
